import { getChartData } from "../chart";
import useDeepMemo from "./use-deep-memo";
function getPromises(...requests) {
    return requests.map((dataRequest) => 
    // Using useDeepMemo inside this callback is only safe because we don't expect the number or
    // order of requests to change.
    useDeepMemo(() => getChartData(dataRequest), dataRequest));
}
export function useGetChartData(...requests) {
    const promises = getPromises(...requests);
    return useDeepMemo(() => {
        if (requests.length === 1) {
            return promises[0];
        }
        return Promise.all(promises);
    }, requests);
}
/**
 * Like `useGetChartData`, but uses Promise.allSettled instead of Promise.all. Will always return
 * an array of results, even if only one request is made.
 *
 * @see useGetChartData
 */
export function useGetChartDataSettled(...requests) {
    const promises = getPromises(...requests);
    return useDeepMemo(() => {
        return Promise.allSettled(promises);
    }, requests);
}
